import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";


import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

import { ContratoServicoForm, ContratoServicoSchema } from "../../../schemas/Contrato/contrato_servico";
import { DropDownProdutoServico } from "../../../../../../common/components/dropdown_produtoservico";
import { FormMoneyMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_money_masked_input";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";


type Props = {
  open: boolean,
  saving: boolean,
  selectedServico: ContratoServicoForm | null,
  IdContrato: number;
  onSubmit: (form: ContratoServicoForm) => void,
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
  onClose: () => void,
};

export const ServicoModal = ({
  open,
  saving,
  IdContrato,
  selectedServico,
  onOpenChangeHistory,
  onSubmit,
  onClose,
}: Props) => {
  const hookForm = useForm<ContratoServicoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ContratoServicoSchema),
  });


  useEffect(() => {
    if (open) {
      if (selectedServico) {
        hookForm.reset({
          Detalhamento: selectedServico.Detalhamento,
          IdContrato: selectedServico.IdContrato,
          IdContratoServico: selectedServico.IdContratoServico,
          IdProdutoServico: selectedServico.IdProdutoServico,
          Quantidade: selectedServico.Quantidade,
          ValorTotal: selectedServico.ValorTotal,
          ValorUnitario: selectedServico.ValorUnitario
        });
      }
      } else {
        hookForm.reset({
          IdContrato: IdContrato,
          IdContratoServico: 0,
          Detalhamento: "",
          IdProdutoServico: 0,
          Quantidade: 0,
          ValorTotal: 0,
          ValorUnitario: 0
        });
      }
  }, [hookForm, open, selectedServico, IdContrato]);

  const handleChangeHistory = useCallback(() => {
    if (selectedServico) {
      onOpenChangeHistory(selectedServico.IdContratoServico, LogTipoTabela.CONTRATO_SERVICO);
    }
  }, [selectedServico, onOpenChangeHistory]);
  const handleSubmit = useCallback((form: ContratoServicoForm) => {
    if (!saving){
      onSubmit(form);
      // hookForm.reset(); 
    } 
  }, [onSubmit, saving]);

  const handleClose = useCallback(() => {
    if (!saving){
      onClose();
      hookForm.reset(); 
    } 
  }, [hookForm, onClose, saving]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
       sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "60rem",
            height: "28rem",
          },
        },
      }}
      >
      <DialogTitle>
        Serviços
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={selectedServico ? "Editar" : "Cadastrar"} arrangement="fullRow">
            <>
              <DropDownProdutoServico
                name='IdProdutoServico'
                label="Serviço"
                placeholder="Serviço"
                required={true}
                reactHookForm={hookForm}
                tipo="S"
              />
                <div className="md:col-span-2">
                  <DefaultFormInput
                    name="Quantidade"
                    label="Quantidade"
                    required={true}
                    reactHookForm={hookForm}
                  />
                </div>
                <FormMoneyMaskedInput
                  name='ValorUnitario'
                  label="Valor Unitário R$"
                  reactHookForm={hookForm}
                />  
            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div className="w-[220px]">
            {
              isNotNullOrUndefined(selectedServico) &&
              <PrimaryButton
                buttonColor="yellow"
                onClick={handleChangeHistory}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>
          <div className="flex flex-row gap-2 w-full justify-end">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}